
import { Routes, Route } from 'react-router-dom';
import Home from './home';
import Footer from './Footer';
import WatchVideo from './WatchVideo';
import Navbar from './Navbar';
import AllVideos from './AllVideos';
import StudentVideos from './StudentVideos';
import TeacherVideos from './TeacherVideos';

function App() {



  return (
      <div className='app'>
        <Navbar/>
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/allvideos" element={<AllVideos />} />
            <Route path="/students" element={<StudentVideos />} />
            <Route path="/teachers" element={<TeacherVideos />} />
            <Route path="/allvideos/:id" element={<WatchVideo />} />
          </Routes>
        </div>
        <Footer />
      </div>
  );
}

export default App;